import styled from "styled-components";

const LinkWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid
    ${({ theme }) => (theme.linkUnderlined ? theme.colors.link : "transparent")};
  padding-bottom: 4px;
`;

export default LinkWrapper;
